import React from "react";
import styles from "./Button.module.css";

/**
 * Reusable Button Component matching the project's coral/white theme.
 *
 * @param {string}  variant   - 'primary' (coral gradient), 'primaryFlat' (solid coral),
 *                               'secondary' (coral outline), 'tertiary' (grey border),
 *                               'outline' (cancel style), 'danger' (red outline),
 *                               'dangerSolid' (red filled), 'ghost' (no border/bg),
 *                               'link' (text link)
 * @param {string}  size      - 'xs', 'sm', 'md' (default), 'lg', 'xl'
 * @param {boolean} disabled  - disables the button
 * @param {boolean} fullWidth - makes button width 100%
 * @param {boolean} loading   - shows loading state
 * @param {string}  loadingText - text to show when loading (default: "Saving…")
 */
const Button = React.forwardRef(function Button({
    children,
    variant = "primary",
    size = "md",
    className = "",
    disabled = false,
    fullWidth = false,
    loading = false,
    loadingText,
    type = "button",
    ...props
}, ref) {
    const isDisabled = disabled || loading;

    const classNames = [
        styles.btnBase,
        styles[variant] || styles.primary,
        styles[size] || styles.md,
        fullWidth && styles.fullWidth,
        className,
    ].filter(Boolean).join(" ");

    return (
        <button
            ref={ref}
            type={type}
            className={classNames}
            disabled={isDisabled}
            {...props}
        >
            {loading ? (loadingText || "Saving\u2026") : children}
        </button>
    );
});

export default Button;
